<template>
	<div
		class="default-card-list"
		:class="{
			'default-card-list--preshow': store.isPreShow,
			'default-card-list--full': isFullwidth,
		}"
	>
		<div class="default-card-list__cards">
			<h2 v-if="cardsTitle" class="default-card-list__title">
				{{ cardsTitle }}
			</h2>
			<div class="default-card-list__grid">
				<DefaultCard
					v-for="card in cards"
					:key="card.id"
					:fields="card.fields"
				></DefaultCard>
			</div>
		</div>
		<div class="default-card-list__cards">
			<h2
				v-if="preShowCardsTitle && preShowCards"
				class="default-card-list__title"
			>
				{{ preShowCardsTitle }}
			</h2>
			<div class="default-card-list__grid">
				<DefaultCard
					v-for="card in preShowCards"
					:key="card.id"
					:fields="card.fields"
				></DefaultCard>
			</div>
		</div>
	</div>
</template>
<script setup>
const store = useAppStore();

const props = defineProps({
	fields: { type: Object, required: true },
	rendering: { type: Object, required: false },
});

const cardsTitle = computed(() => props.fields?.cardsTitle?.value);
const cards = computed(() => props.fields?.cards);
const preShowCardsTitle = computed(
	() => props.fields?.preShowCardsTitle?.value
);
const preShowCards = computed(() => props.fields?.preShowCards);
const isFullwidth = computed(() => props.fields?.fullwidth);
</script>

<style lang="scss">
.default-card-list {
	display: flex;
	flex-direction: column;
	padding: var(--spacing-2, 16px);

	.default-card-list__title {
		color: var(--color-white, #fff);
		font-style: normal;
		font-weight: 300;
		line-height: 120%;
	}

	.default-card-list__grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: var(--spacing-2, 16px);
	}

	&.default-card-list--full .default-card-list__grid {
		grid-template-columns: repeat(1, minmax(0, 1fr));

		.default-card:before {
			padding-top: 0;
		}

		.default-card__content {
			display: grid;
			row-gap: 0;
			grid-template-columns: auto 1fr;
			grid-template-areas:
				"icon title"
				"content content";

			.default-card__icon {
				grid-area: icon;
				width: auto;
			}

			.default-card__title {
				grid-area: title;
				display: flex;
				align-items: center;
			}
			.default-card__inner-content {
				grid-area: content;
			}
		}
	}

	&.default-card-list--preshow {
		flex-direction: column-reverse;
	}
}
</style>
